import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useAppContext } from '../Context';
import { motion } from 'framer-motion';

const Checkout = () => {
	const { psServer, packageChoice, submittedCode, setIsLoading, setPaymentID, clickedImage } = useAppContext();
	
	const navigate = useNavigate();
	const [middleMessage, setMiddleMessage] = useState('Please wait...');
	const [paymentFailed, setPaymentFailed] = useState(false);
	
	const getPaymentLink = async() => {
		setIsLoading(true);
		const response = await fetch(psServer + `/payment/start`, {
			method: "POST",
			headers: {
				"Content-type": "application/json",
			},
			body: JSON.stringify({
				submittedCode: submittedCode,
				packageChoice: packageChoice,
				clickedImage: clickedImage
			})
		});
		const data = await response.json();
		if (!data?.gatewayResponse) {
			setIsLoading(false);
			navigate('/');
			return;
		}
		if (!data?.gatewayResponse?.id) {
			setIsLoading(false);
			navigate('/');
			return;
		}
		setPaymentID(data.gatewayResponse.id);
		data.status === "success" ? window.location.href = data.gatewayResponse.url : setPaymentFailed(true);
		setIsLoading(false);
	};
	
	useEffect(() => {
		if (paymentFailed) {
			setMiddleMessage('Payment Failed');
			var navigateTo = `/?qr=${submittedCode}`;
			if (submittedCode === null) {
				navigateTo = '/';
			}
			setTimeout(function(){navigate(navigateTo)}, 5000);
		}
	},[paymentFailed]);
	
	useEffect(() => {
		/*
		if (paymentGateway !== "paypal") {
			getPaymentLink();
		}
		*/
		getPaymentLink();
	},[]);
	
	return (
		<div className="landing">
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 1, ease: 'easeInOut' }}
				style={{width: '100%', maxWidth: '600px'}}
			>
				{middleMessage}
			</motion.div>
		</div>
	);
};

export default Checkout;